import { render, staticRenderFns } from "./CongratsMessage.vue?vue&type=template&id=0a4e4662&scoped=true"
import script from "./CongratsMessage.vue?vue&type=script&lang=js"
export * from "./CongratsMessage.vue?vue&type=script&lang=js"
import style0 from "./CongratsMessage.vue?vue&type=style&index=0&id=0a4e4662&prod&lang=scss&scoped=true"
import style1 from "./CongratsMessage.vue?vue&type=style&index=1&id=0a4e4662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e4662",
  null
  
)

export default component.exports